import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { formatFsdbmThreshold } from '../../../components/helper/utils'

export const FSDBMMessage = ({ threshold }) => {
  const formattedThreshold = formatFsdbmThreshold(threshold); 
  return (
    <div data-testid="fsdbm-message" className="sui-pt-1">
      <Typography variant="body-sm" height="normal">
        <span className="sui-text-success sui-font-bold">{'FREE '}</span>
        <span className="sui-font-bold">Delivery Today</span>
        {` with $${formattedThreshold} of eligible items`}
      </Typography>
    </div>
  )
};

FSDBMMessage.propTypes = {
  threshold: PropTypes.string
};

FSDBMMessage.defaultProps = {
  threshold: ''
};
